import styled from 'styled-components';
import { s32 } from '@ardoq/design-tokens';
import {
  DASHBOARD_COL_NUMBER,
  DASHBOARD_GAP,
  DASHBOARD_MAX_WIDTH,
  DASHBOARD_MIN_SCREEN_WIDTH_SMALL,
  WIDGETS_GRID_MIN_WIDTH,
} from '../../consts';

export const WidgetsContainer = styled.div.attrs({
  role: 'grid',
  'aria-label': 'Dashboard widgets',
})`
  display: grid;
  /* minmax(0, ...) rather than 1fr so that wide widget content cannot force a
     column past its share of the width. */
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: auto;
  gap: ${DASHBOARD_GAP}px;
  max-width: ${DASHBOARD_MAX_WIDTH}px;
  padding-bottom: ${s32};

  @media (min-width: ${DASHBOARD_MIN_SCREEN_WIDTH_SMALL}px) {
    grid-template-columns: repeat(${DASHBOARD_COL_NUMBER}, minmax(0, 1fr));
    min-width: ${WIDGETS_GRID_MIN_WIDTH}px;
  }
`;
